export interface FilenamePrefixState {
    readonly prefixConfigsJson:string
}

export const FilenamePrefixActionTypes = {
  SET_PREFIX_CONFIGS: "@@filenamePrefix/SET_FILENAME_PREFIX"
}
